<template>
  <div class="tabs_container" v-if="navList?.length>0">
    <div class="tabs_container_wrap">
      <div class="tabs_nav">
        <ul>
          <li
            class="tabs_nav_item"
            v-for="(item, index) in navList"
            :key="index"
            :class="currentIndex == index ? 'tabs_nav_choose' : ''"
            @click="goTab(item.id, index, item.type, item.name)"
          >
            {{ item.name }}
            <img
              v-if="currentIndex == index"
              class="tabs_nav_item_img"
              src="@/assets/image/tab1.png"
              alt=""
            />
          </li>
        </ul>
      </div>

      <div class="tabs_detail">
        <div class="tabs_detail_title">{{ currentName }}</div>
        <ul v-if="currentType == 'article'">
          <li
            v-for="(article, index) in navArticleInfo.data"
            :key="index"
            class="tabs_detail_content_item"
            @click="goDetailArticle(article.id)"
          >
            <div class="tabs_detail_content_item_left">
              <img
                class="tabs_detail_content_item_left_img"
                src="@/assets/image/tab2.png"
                alt=""
              />
              <span>{{ article.title }}</span>
            </div>
            <div class="tabs_detail_content_item_right">
              {{ article.article_date }}
            </div>
          </li>
        </ul>
        <div
          class="tabs_detail_content"
          v-html="chooseNav.content"
          v-else
        ></div>
        <Pagination
          class="pagination"
          :total="navArticleInfo.total"
          :pageSize="pageSize"
          :pageNow="currentPage"
          :continues="10"
          :sendPageNow="getPageNow"
          v-if="
            currentType == 'article' &&
            navArticleInfo.data &&
            navArticleInfo.data.length
          "
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import Pagination from "@/components/common/pagination.vue";
export default {
  name: "NavMenu",
  data() {
    return {
      currentPage: 1,
      currentId: 1,
      chooseNav: {},
      currentIndex: 0,
      currentType: "content",
      currentName: "",
      pageSize: 10,
    };
  },
  components: { Pagination },
  props:{
    navList:{
      type: Array,
      default: ()=>[],
    }
  },
  methods: {
    // 获取点击后的页码
    getPageNow(n) {
      //更新参数
      this.currentPage = n;
      //发请求
      this.$store.dispatch("getNavArticleData", {
        id: this.currentId,
        currentPage: n,
        pageSize: this.pageSize,
      });
    },
    goDetailArticle(id){
      this.$router.push({
          name: 'detail',
          query: {
            id:id,
            type: 'article',
            scene: 4,
            nav_id: this.currentId,
            keyword:'',
          } 
      });
    },
    goTab(id, index, type, name) {
      this.currentId = id;
      this.currentIndex = index;
      this.currentType = type;
      this.currentName = name;
      this.currentPage =1;
      if (type == "article") {
        this.$store.dispatch("getNavArticleData", {
          id: id,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        });
      } else if (type == "content") {
        this.chooseNav = this.navList.find((item) => item.id == id);
        console.log(this.chooseNav);
      }
    },
  },
  computed: {
    ...mapState({
      // navList: (state) => state.kindness.nav,
      navArticleInfo: (state) => state.material.navArticleInfo,
    }),
  },
  watch: {
    // "$store.state.kindness.nav": {
      navList:{
      deep: true,
      handler(newData) {
        this.currentType = newData[0].type;
        this.currentId = newData[0].id;
        this.currentName = newData[0].name;
        if (newData[0].type == "article") {
          this.$store.dispatch("getNavArticleData", {
            id: this.currentId,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          });
        } else {
          this.chooseNav = newData[0];
        }
      },
    },
  },
  // mounted() {
  //   this.$store.dispatch("getKindnessData");
  // },
};
</script>
  
  <style scoped lang="stylus">
  .tabs_container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tabs_container_wrap {
      width: 1180px;
      display: flex;

      .tabs_nav {
        width: 230px;
        height: 100%;

        ul {
          .tabs_nav_item {
            position: relative;
            width: 100%;
            height: 50px;
            font-size: 16px;
            font-family: SourceHanSansCN-Normal SourceHanSansCN;
            line-height: 50px;
            text-align: center;
            color: #666;
            cursor: pointer;

            .tabs_nav_item_img {
              width: 10px;
              height: 12px;
              position: absolute;
              top: 18px;
              right: 18px;
            }
          }

          .tabs_nav_choose {
            background: #014EA2;
            color: #fff;
          }
        }
      }

      .tabs_detail {
        width: 100%;
        padding-left: 70px;
        padding-bottom: 55px;
        box-sizing: border-box;
        border-left: 1px solid #F5F5F5;
        position: relative;

        .tabs_detail_title {
          width: 100%;
          height: 50px;
          border-bottom: 1px solid #F5F5F5;
          font-size: 36px;
          font-family: SourceHanSansCN-Normal SourceHanSansCN;
          font-weight: 500;
          color: #000000;
          margin-bottom: 40px;
          line-height: 35px;
        }

        ul {
          padding-bottom: 60px;
          position: relative;
          .tabs_detail_content{
            :deep(img){
                max-width: 100%;
            }
            :deep(ol){
                margin-left: 30px;
            }
            :deep(ul){
                margin-left: 30px;
            }
          }

          .tabs_detail_content_item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #000000;
            padding: 10px 0;

            .tabs_detail_content_item_left {
              width:85%;
              cursor: pointer;
              display: flex;
              &:hover span{
                color: #014EA2;
              }
              .tabs_detail_content_item_left_img {
                width: 20px;
                height: 20px;
                margin-right: 16px;
                padding-top: 2px;
              }
              span{
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                display: block;
                text-overflow: ellipsis; 
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
              }
            }

            .tabs_detail_content_item_right {
              width: 13%;
              font-size: 14px;
              color: #666;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
            }
          }
        }

        .pagination {
          position: absolute;
          bottom: 0;
          left: 70px;
        }
      }
    }
  }
</style>